module.exports = __webpack_public_path__ + "static/media/shutterstock_615849746.c269b20a.jpg";